class CuttingObject {
  decorId = Number
  name = 'Dielec'
  material = null
  description = ''
  width = 400
  height = 300
  thickness = 18
  quantity = 1
  edge = {
    front: null,
    back: null,
    left: null,
    right: null,
  }
  duplex = false
  rotate = false
}

export default CuttingObject